import React, { useState } from 'react';
import { Button } from 'primereact/button';
import './ExerciseViewIcon.scss';
import { RoutineExercise } from '../../types/Fisiofit/routine';
import { ExerciseMediaModal } from '../ExerciseMediaModal/ExerciseMediaModal';
import { getVideoEmbedUrl, isEmbeddableVideo } from '../../utils/videoEmbedUtils';

interface Props {
  exercise: RoutineExercise;
}

export const ExerciseViewIcon = ({ exercise }: Props) => {
  const [isMediaModalVisible, setIsMediaModalVisible] = useState(false);

  const handleViewExerciseMedia = async (e: React.MouseEvent) => {
    e.preventDefault();
    e.stopPropagation();
    setIsMediaModalVisible(true);
  };

  return (
    <div className='exercise-view-icon'>
      <Button icon='pi pi-eye' rounded className='exercise-media-button' onClick={handleViewExerciseMedia} />
      {isMediaModalVisible && (
        <ExerciseMediaModal
          visible={isMediaModalVisible}
          onHide={() => setIsMediaModalVisible(false)}
          exercise={exercise}
          getVideoEmbedUrl={getVideoEmbedUrl}
          isEmbeddableVideo={isEmbeddableVideo}
        />
      )}
    </div>
  );
};
